import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VConsole from "vconsole"
// var vConsole = new VConsole();

// 引入hotcss
import './lib/hotcss/hotcss.js'
//全局引用echarts图表
import echarts from "echarts";
//请求接口
import API from "./common/api/api"
import CONFIG from "./common/config"
//引入vant
import {
    Sidebar,
    SidebarItem,
    TreeSelect,
    Tab,
    Tabs,
    Field,
    Button,
    Overlay,
    Uploader,
    Toast,
    RadioGroup,
    Radio,
    CountDown,
    Progress,
    Area,
    Checkbox,
    Popup,
    Empty,
    Swipe,
    SwipeItem,
    Tabbar,
    TabbarItem,
    DropdownMenu,
    DropdownItem,
    Dialog,
    Loading,
    Divider,
    Pagination,
} from 'vant';
Vue.use(Loading);
Vue.use(Divider);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(TreeSelect);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Button);
Vue.use(Overlay);
Vue.use(Uploader);
Vue.use(Toast);
Toast.setDefaultOptions({ duration: 5000 });
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(CountDown);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dialog);
Vue.use(Pagination);


Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
//注册一个全局守卫
router.beforeEach(async (to, from, next) => {
    let token = localStorage.getItem('token');

    //用户未登录进行登录
    if (!token) {
        if (to.query.code) {
            //code存在请求 请求接口code换取token
            try {
                let code = await API.getJson('LOGIN', { code: to.query.code }).then((res) => {
                    if (res.token) {
                        localStorage.setItem('token', res.token);
                    }
                });
            } catch (err) {
                console.log(err);
            }
            next();
        } else {
            // 测试使用
            // localStorage.setItem('token', '38d6821f27e54d51abdae63824378b93'); //1054eb44722c4674958b41e1d2151f0b
            // code不存在 跳转到微信侧换取code
            let APPID = CONFIG.APPID;
            let pageUrl = window.location.protocol + '//' + window.location.host;
            let wechatAuth2URL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + encodeURIComponent(pageUrl) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
            window.location.href = wechatAuth2URL;

            next();
        }
    } else {
        next()
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')